import { omit } from 'lodash';
import { network } from 'services/network';

import { IExportCsvReportPayload } from 'api/mutations/exportCsvReport.mutation';

export const exportCsvReport = (params: IExportCsvReportPayload) => {
    return network
        .post('api/bo/exportCsvReport', omit(params, 'fileName'), {
            responseType: 'arraybuffer',
        })
        .then((response) => {
            const blob = new Blob([response.data]);
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = params.fileName;
            a.click();

            return true;
        });
};
